import { Api } from "../util/Api";
import { Inspection } from "./Inspection";

export class InspectionPart {
	constructor(props) {
		this.name = null;
		this.partNumber = null;
		this.position = null;
		this.notes = null;
		this.ordered = false;
		this.replaced = false;
	}

	static hydrate(ip) {
		let hIp = new InspectionPart();
		Object.assign(hIp, ip);

		if(hIp.inspection != null) {
			hIp.inspection = Inspection.hydrate(hIp.inspection);
		}

		return hIp;
	}

	async sendToServer(user) {
		await Api.forProfile(user).inspectionCall(`/v2/inspection_parts/${encodeURIComponent(this.id)}`, "PUT", this)
	}

	async buildPartsFinderUrl(parentInsp) {
		if(parentInsp == null) {
			parentInsp = this.inspection; // Direct loads of inspection part includes the inspection
		}
		let partNum = this.partNumber;
		if(!partNum) {
			partNum = parentInsp.primaryComponent.modelNumber;
			if(!partNum) {
				let snum = parentInsp.componentSerialNumber;
				if(!!snum) {
					let sdata = await Api.dataForSerial(snum);
					partNum = sdata.partNumber;
				}
			}
		}
		if(!partNum) {
			return "https://fusion.mcelroy.com/parts/exec";
		} else {
			return `https://fusion.mcelroy.com/parts/exec?service=external/Home&sp=S${partNum}`
		}
	}

	static async getParts(user, search = {}) {
		let usp = new URLSearchParams(search);
		let parts = await Api.forProfile(user).inspectionCall(`/v2/inspection_parts?${usp.toString()}`, "GET");
		return parts.map(part => InspectionPart.hydrate(part));
	}
}